// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federbeschichtung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federbeschichtungDE: PageEntry = {
  id: "post.federbeschichtung",
  locale: "de",
  slug: "federbeschichtung",
  seo: {
    title: "Glossar: Federbeschichtung einfach erklärt | Dietz GmbH",
    description: "Federbeschichtung bezeichnet die Anwendung einer speziellen Beschichtung auf die Oberfläche einer Feder. Diese Beschichtungen dienen dazu, die Reibung zu reduzieren, die Korrosions",
  },
  type: "post",
  h1: "Glossar: Federbeschichtung einfach erklärt",
  intro: "Federbeschichtung bezeichnet die Anwendung einer speziellen Beschichtung auf die Oberfläche einer Feder. Diese Beschichtungen dienen dazu, die Reibung zu reduzieren, die Korrosionsbeständigkeit zu verbessern oder spezifische mechanische Eigenschaften der Feder zu modifizieren. Die Auswahl der richtigen Federbeschichtung hängt von den Umgebungsbedingungen, den Anforderungen der Anwendung und den Materialeigenschaften der Feder ab. Eine qualitativ hochwertige Federbeschichtung trägt dazu bei, die Lebensdauer der Feder zu verlängern und ihre Leistungsfähigkeit zu optimieren.",
  blocks: [

  ],
};
